import { deleteDescuento, getDescuentosPanel} from "../../services/DescuentosServices";
import { DescuentosContext } from "./DescuentosContext"

export const DescuentosState = ({ children }) => {
    const getDescuentosPanelData = async (searchTerm,numPagina, filas) => {
        let res = await getDescuentosPanel(searchTerm,numPagina, filas);
        return res;
    }

    const deleteDescuentoData = async (body,search,numpag,filas) => {
        const res = await deleteDescuento(body)
        if (res) getDescuentosPanelData()
        return res
    }

    return <DescuentosContext.Provider value={{
        deleteDescuentoData,
        getDescuentosPanelData,
    }} >
        {children}
    </DescuentosContext.Provider>
}